export default {
  InMemoryIcon: 'inMemoryIcon',
  CalendarIcon: 'calendarIcon',
  TeamIcon: 'teamIcon',
};
